import { FirebaseError } from 'firebase/app';

import { postRequest } from '../../services/api';
import type { ApiResponse } from '../../services/types';

// Firebase answers a force-reset account like any wrong password, so only these codes are worth asking about.
const FORCE_RESET_CANDIDATE_CODES = new Set(['auth/invalid-credential', 'auth/wrong-password']);

/** Whether a rejected email + password sign-in belongs to an account force reset from the admin. */
export async function isForcePasswordReset(error: unknown, email: string): Promise<boolean> {
  if (!(error instanceof FirebaseError) || !FORCE_RESET_CANDIDATE_CODES.has(error.code) || !email) {
    return false;
  }

  try {
    const response = await postRequest<ApiResponse<boolean, 'forceReset'>>('/v2/user/password-reset-status', {
      email,
    });
    return response.data?.forceReset === true;
  } catch {
    return false;
  }
}
